import { Select } from 'antd';

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const UPPER_LIMIT = 2099;
const LOWER_LIMIT = 1970;

const SelectYear: React.FC<Props> = (props) => {
  const { value = 2055, onChange } = props;
  const nepaliYears = Array.from(
    { length: UPPER_LIMIT - LOWER_LIMIT + 1 },
    (_, index) => ({
      label: UPPER_LIMIT - index,
      value: UPPER_LIMIT - index,
    }),
  );

  return (
    <Select
      size="small"
      popupMatchSelectWidth={false}
      options={nepaliYears}
      suffixIcon={null}
      value={value}
      onChange={onChange}
      variant="borderless"
      labelRender={({ label }) => (
        <div className="tw-font-semibold tw-text-white">{label}</div>
      )}
    />
  );
};

export default SelectYear;
